/**
 * @file: storeFeatureCatalog.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { StoreFeature } from '@euler/model/enum';

/**
 * The features whose work spends AI credits, mirrored from `usesAiCredits`
 * in the backend's feature catalogue
 * (`packages/models/src/entitlements/storeFeatures.ts`): their trials share
 * the store's trial credits.
 */
export const kAiCreditFeatures: readonly StoreFeature[] = [
  StoreFeature.ChatBot,
  StoreFeature.Apdm,
  StoreFeature.MomentPoster,
  StoreFeature.PosterStudio,
  StoreFeature.Bi,
  StoreFeature.AiAssistant,
  StoreFeature.Coaching,
  StoreFeature.VoiceInput,
  StoreFeature.VoiceSynthesis,
];
